import { createReducer } from 'redux-act';
import { IApp } from './INode';

const appList = window['$$_kxl_config']['appList'];
for(let key in appList){
    if(typeof appList[key] === 'string'){
        appList[key] = JSON.parse(appList[key]);
    }
}

const reducer = createReducer(
    {},
    {
        'rootConfig': window['$$_kxl_config']['rootConfig'],
        'appList': {
            // pact: window['ktsConfig'].appList.pact,
            // domain: window['ktsConfig'].appList.domain,
            map: new Map<string, IApp>(Object.entries(window['$$_kxl_config']['appList']))
        }
    }
);

export default reducer;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/config/reducer.ts